<template>
	<div v-if="transferInputRecordFormVisible" style="width: 100%">
		<lcsj-filter :show-search="false" more-text="更多筛选" @search="inputChange()">
			<template #query>
				<el-button size="small" type="primary" class="el-icon-search" @click="search()">搜索</el-button>
			</template>
			<template #actions></template>
			<el-form-item label="所属门店：">
				<el-select v-model="formInline.storeKeyId" placeholder="请选择门店" clearable filterable size="small" @change="inputChange">
					<el-option v-for="item in storeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="入库单号：">
				<el-input v-model="formInline.code" placeholder="请输入商品编码" clearable size="small" @change="inputChange"></el-input>
			</el-form-item>
			</lcsj-filter>
		<STable :columns="columnsData" :data="listData" :loading="loading" border stripe>
			<template #isConfirm>
				<el-table-column label="是否确认" min-width="120" align="center">
					<template #default="scope">
						<el-tag v-if="scope.row.isConfirm" type="success">已确认</el-tag>
						<el-tag v-else type="danger">未确认</el-tag>
					</template>
				</el-table-column>
			</template>
		</STable>
		<!-- 分页组件 -->
		<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
	</div>
</template>

<script>
import { GetStoreProductHistoryPageList } from "@/api/productApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
export default {
	watch: {
		transferInputRecordFormVisible(visible) {
			if (!visible) return;
			this.GetOrgInfoListByConfig();
		}
	},
	data() {
		return {
			transferInputRecordFormVisible: false,
			pageShow: true,
			loading: false, // 显示加载
			listData: [],
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				storeKeyId: "",
				typeName: "",
				productName: "",
				code: "",
				productTypeKeyId: "",
				type: 2,
				isConfirm: true,
				storeProductKeyId: ""
			},
			columnsData: [], //显示列
			listColumns: [
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "80",
					isKeep: true
				},
				{
					prop: "storeName",
					label: "门店名称",
					isKeep: true,
					minWidth: "120",
					align: "center",
				},
				{
					prop: "code",
					label: "入库单号",
					isKeep: true,
					minWidth: "200",
					align: "center",
				},
				{
					prop: "productInfo.code",
					label: "商品编码",
					isKeep: true,
					minWidth: "170",
					align: "center",
				},
				{
					prop: "productInfo.typeName",
					label: "类型名称",
					width: "120",
					align: "center"
				},
				{
					prop: "productInfo.productName",
					label: "商品名称",
					width: "180",
					align: "center"
				},
				{
					prop: "productInfo.specification",
					label: "规格",
					width: "150",
					align: "center"
				},
				{
					prop: "productInfo.unit",
					label: "单位",
					width: "120",
					align: "center"
				},
				{
					prop: "price",
					label: "价格(元)",
					width: "120",
					align: "center",
					isMoney: true,
					moneyType: "normal"
				},
				{
					prop: "quantity",
					label: "入库数量",
					width: "120",
					align: "center"
				},
				{
					prop: "typeName",
					label: "入库类型",
					width: "120",
					align: "center"
				},
				{
					prop: "content",
					label: "入库内容",
					width: "120",
					align: "center"
				},
				{
					prop: "remark",
					label: "入库备注",
					width: "120",
					align: "center"
				},
				{
					prop: "productDate",
					label: "生产日期",
					width: "120",
					align: "center"
				},
				{
					prop: "expireDate",
					label: "过期日期",
					width: "120",
					align: "center"
				},
				{
					slot: "isConfirm",
					label: "是否确认",
					width: "120",
					align: "center"
				},
				{
					prop: "confirmUserName",
					label: "确认人",
					width: "120",
					align: "center"
				},
				{
					prop: "confirmTime",
					label: "确认时间",
					width: "170",
					align: "center"
				},
				{
					prop: "creator",
					label: "创建人",
					width: "120",
					align: "center"
				},
				{
					prop: "createTime",
					label: "创建时间",
					width: "170",
					align: "center"
				},
				{
					prop: "editor",
					label: "维护人",
					width: "120",
					align: "center"
				},
				{
					prop: "updateTime",
					label: "维护时间",
					width: "170",
					align: "center"
				},
				{
					slot: "operation",
					label: "操作",
					width: "120",
					align: "center"
				}
			],
			storeList: []
		};
	},
	// 注册组件
	components: {},
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));

	},
	computed: {},
	methods: {
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		// 显示弹窗
		showTransferInputRecordDialog(keyId, type) {
			this.transferInputRecordFormVisible = true;
			this.formInline.storeProductKeyId = keyId;
			this.formInline.type = type;
			this.search();
		},
		// 关闭弹窗
		closeTransferInputRecordDialog() {
			this.transferInputRecordFormVisible = false;
		},
		// 获取所属门店
		GetOrgInfoListByConfig() {
			const paramer = {
				key: 1
			};
			GetOrgInfoListByConfig(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.storeList = [];
						if (res.code == 1) {
							res.data.forEach((item) => {
								this.storeList.push({
									keyId: item.keyId,
									value: item.name + "【" + item.remark2 + "】"
								});
							});
						} else {
							this.$message.error(res.msg);
						}
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取门店信息失败!");
				});
		},
		changePages() {},
		// 获取列表
		getListData() {
			this.loading = true;
			GetStoreProductHistoryPageList(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.loading = false;
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		// 重置
		clearAll() {
			this.$data.formInline = this.$options.data.call(this).formInline;
			this.search();
		},
		inputChange(val) {
			this.search();
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		// 搜索事件
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		}
	}
};
</script>

<style scoped>

</style>
